import store from '@/store';
import CalculateFMCService from '@/services/DataProcess/CalculateFMCService'

const DataWatcherService = {
  unwatchers: [],

  init() {
    this.watchProximityDetail();
  },

  watchProximityDetail() {
    const unwatch = store.watch(
      (state) => state.ancientProxResult.openedAncientProxDetail,
      async (newValue, oldValue) => {
        if (newValue !== oldValue) {
          if (newValue) {
            this.clearCaculated();
            
            const sourceDataResult = await store.dispatch('ancientProxSourceData/fetchAncientProxSourceData');
            if (!sourceDataResult) {
              return;
            }
            
            await this.setTargetSourceDataAndRun(sourceDataResult.sourceData, newValue.sourceCodes);
            await this.runSampleDistance();
          }
        }
      }
    );

    this.unwatchers.push(unwatch);
  },

  clearCaculated() {
    store.state.geneticSimilarities.proximityCalculatedResult = [];
  },

  async setTargetSourceDataAndRun(sourceData, sourceCodes) {
    const resolveAncientSource = CalculateFMCService.codeDataToArray(sourceData);
    if (!resolveAncientSource.isSuccess) {
      return;
    }
    const targetSourceData = resolveAncientSource.result.filter(x => x[0] === sourceCodes);
    if (targetSourceData.length) {
      CalculateFMCService.onSetTarget(targetSourceData);
    }
  },

  async runSampleDistance() {
    try {
      const sourceDataResult = await store.dispatch('modernSourceData/fetchModernSourceData');
      if (!sourceDataResult) {
        return;
      }

      const resolveSource = CalculateFMCService.codeDataToArray(sourceDataResult.sourceData);
      if (resolveSource.isSuccess) {
        CalculateFMCService.onSetSource(resolveSource.result);
      }

      CalculateFMCService.dataObject.maxDistOutPut = 10;
      const calculatedResult = await CalculateFMCService.calculateDistance(0);
      store.state.geneticSimilarities.proximityCalculatedResult = calculatedResult;
    } catch (error) {
      console.error('Error handling specific state change:', error);
    }
  },

  cleanup() {
    this.unwatchers.forEach(unwatch => unwatch());
    this.unwatchers = [];
  },
};

export default DataWatcherService;
